import type { TableRowProps as ChakraTableRowProps } from '@chakra-ui/react';
import { Tr as ChakraTr } from '@chakra-ui/react';
import React from 'react';

import type { OmitChakraProps } from '../../utils/typeUtils';
import { withChakraAs } from '../../utils/withChakraAs';

export type TableRowProps = OmitChakraProps<ChakraTableRowProps>;

export const Tr = withChakraAs<TableRowProps, 'tr'>((props) => {
  return <ChakraTr {...props} />;
});
